/* eslint-disable react/jsx-indent */
import React, { Component } from 'react'
import { Card, CardBody, Media } from 'reactstrap'

class FinCard extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { title, value, previous_var, planned_var,interpretation } = this.props
    let ptBR = Intl.NumberFormat("pt-BR", {
      style: "decimal",
      currency: "BRL",
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    })
    return (
      <Card>
        <CardBody>
          <Media>
            <Media body className="overflow-hidden">
              <p className="text-truncate font-size-14 mb-2">{title}</p>
              <h4 className="mb-0">R$ {ptBR.format(value)}</h4>
            </Media>
          </Media>
        </CardBody>
        <CardBody className="border-top py-3">
        <div className="text-truncate">
          <span className={(interpretation*previous_var)>0 ? 'badge-success badge-pill font-size-11 mr-1' : 'badge-danger badge-pill font-size-11 mr-1'}>
          {ptBR.format(Math.abs(previous_var)*100)} % <i className={previous_var>0 ? ('ri-arrow-up-fill') : ('ri-arrow-down-fill')} />
          </span>
          <span className="text-muted ml-1">
            em relação ao ano anterior
          </span>
        </div>
        <div className="text-truncate">
          <span className={(interpretation*planned_var)>0 ? 'badge-success badge-pill font-size-11 mr-1' : 'badge-danger badge-pill font-size-11 mr-1'}>
            {ptBR.format(Math.abs(planned_var)*100)} % <i className={planned_var>0 ? ('ri-arrow-up-fill') : ('ri-arrow-down-fill')} />
          </span>
          <span className="text-muted ml-1">
            em relação ao previsto
          </span>
        </div>
        </CardBody>
      </Card>
    )
  }
}
export default FinCard
